import axios from 'axios';
import type { Treatment } from '../types/treatment';
import { mockMassages, mockYogatherapy } from '../data/mockTreatments';

const api = axios.create({
  baseURL: '/api/method/bmapp.utils.api',
});

export async function fetchMassages(): Promise<Treatment[]> {
  try {
    const response = await api.get('get_massage');
    return response.data.message;
  } catch (error) {
    console.error('Error fetching massages:', error);
    return mockMassages;
  }
}

export async function fetchYogatherapy(): Promise<Treatment[]> {
  try {
    const response = await api.get('get_yogatherapie');
    return response.data.message;
  } catch (error) {
    console.error('Error fetching yogatherapy:', error);
    return mockYogatherapy;
  }
}